import { ArrowUp } from "iconoir-react";
import "./../HelpLink.scss";

const ScrollWidget = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button className="scroll-widget" onClick={scrollToTop}>
      <span>
        <ArrowUp color="white" />
      </span>
    </button>
  );
};

export default ScrollWidget;
